import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AuthCard from '../components/AuthCard';
import PasswordField from '../components/PasswordField';
import { Alert, SubmitButton } from '../components/Feedback';
import { candidateApi } from '../services/pspApi';
import { isStrongPassword } from '../constants/options';

const ResetPassword = () => {
    const { friendly_url } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const base = `/processos-seletivos/${friendly_url}`;
    const token = searchParams.get('token');

    const [form, setForm] = useState({ password: '', confirm_password: '' });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (name, value) => {
        setForm((current) => ({ ...current, [name]: value }));
        setErrors((current) => ({ ...current, [name]: undefined }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');

        const found = {};
        if (!isStrongPassword(form.password)) found.password = 'A senha não atende aos requisitos.';
        if (form.password !== form.confirm_password) found.confirm_password = 'As senhas não conferem.';
        if (Object.keys(found).length > 0) {
            setErrors(found);
            return;
        }

        setLoading(true);
        const result = await candidateApi.resetPassword(token, form.password);
        setLoading(false);

        if (result && result.status === 1) {
            setDone(true);
        } else {
            setMessage((result && result.message) || 'Não foi possível redefinir a senha.');
        }
    };

    if (!token) {
        return (
            <div className="psp-center psp-center--padded">
                <AuthCard icon="fa-exclamation-triangle" title="Link inválido" subtitle="O link de redefinição está incompleto ou expirou.">
                    <button type="button" className="psp-btn psp-btn--primary" onClick={() => navigate(`${base}/recuperar-senha`)}>
                        Solicitar novo link
                    </button>
                </AuthCard>
            </div>
        );
    }

    return (
        <div className="psp-center psp-center--padded">
            <AuthCard icon="fa-lock" title="Nova senha" subtitle="Defina uma nova senha para a sua conta.">
                {done ? (
                    <div className="psp-stack">
                        <Alert type="success">Senha redefinida com sucesso. Você já pode acessar a sua conta.</Alert>
                        <button type="button" className="psp-btn psp-btn--primary" onClick={() => navigate(`${base}/login`)}>
                            Ir para o login
                        </button>
                    </div>
                ) : (
                    <form className="psp-stack" onSubmit={handleSubmit} noValidate>
                        <Alert type="error">{message}</Alert>
                        <PasswordField name="password" label="Nova senha" value={form.password} onChange={handleChange} error={errors.password} required showRules autoComplete="new-password" />
                        <PasswordField name="confirm_password" label="Confirmar nova senha" value={form.confirm_password} onChange={handleChange} error={errors.confirm_password} required autoComplete="new-password" />
                        <SubmitButton loading={loading}>Redefinir senha</SubmitButton>
                    </form>
                )}
            </AuthCard>
        </div>
    );
};

export default ResetPassword;
